// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__iBWfi","contentSm":"styles_contentSm__jbiTu","contentMd":"styles_contentMd__BfwC6"};